import styled from 'styled-components'

export const UserSettingsContainer = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  height: 8.4rem;
`
